module.exports = __webpack_public_path__ + "img/orange-5.96794de0.png";